module.exports = __webpack_public_path__ + "img/icon-raiden.35654cd6.webp";